@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Produtos</div>
    </div>
    <ul ngbNav #t="ngbNav" class="nav-tabs" (navChange)="alterarAbas($event)" [(activeId)]="tabSelecionada">
      <!-- Campanhas -->
      <li [ngbNavItem]="'campanhas'">
        <a ngbNavLink>
          <b>Campanhas</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <div class="d-flex justify-content-end">
              <button class="btn btn-secondary btn_titulo" type="button" (click)="novoProdutoCampanha()">Nova Campanha</button>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th></th>
                    <th class="tabela_borda"></th>
                    <th class="tabela_borda"></th>
                    <th class="tabela_borda">Nome</th>
                    <th class="text-center tabela_borda">Ativo</th>
                    <th class="text-center tabela_borda">Kit/Combo</th>
                    <th class="text-center tabela_borda">Preço/Bonificação</th>
                    <th class="text-center tabela_borda">Bonificação (Multiplicável)</th>
                    <th class="text-center tabela_borda">Bonificação (Selecionável)</th>
                    <th class="text-center tabela_borda">Qtde Mínima</th>
                  </tr>
                </thead>
                <tbody>
                  @for (produtoCampanha of produtosCampanhaPaginados; track produtoCampanha; let i = $index) {
                    <tr>
                      <td class="text-center tabela_acao">
                        <i class="fa  btn_tabela_acao" [ngClass]="i == produtoCampanhaExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirProdutoCampanha(i, produtoCampanha.id)"></i>
                      </td>
                      <td class="text-center tabela_acao tabela_borda">
                        <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarProdutoCampanha(produtoCampanha.id)"></i>
                      </td>
                      <td class="text-center tabela_acao tabela_borda">
                        <i class="fa fa-history btn_tabela_acao" placement="right" ngbTooltip="Ver Log" (click)="abrirLogPromo(produtoCampanha.id, produtoCampanha.nome)"></i>
                      </td>
                      <td class="tabela_borda">{{ produtoCampanha.nome }}</td>
                      <td class="text-center tabela_borda">{{ produtoCampanha.is_active ? 'Sim' : 'Não' }}</td>
                      <td class="text-center tabela_borda">{{ produtoCampanha.kit_combo == 'K' ? 'Kit' : 'Combo' }}</td>
                      <td class="text-center tabela_borda">{{ produtoCampanha.preco_bonificacao == 'P' ? 'Preço' : 'Bonificação' }}</td>
                      <td class="text-center tabela_borda">{{ produtoCampanha.bonificacao_multiplicavel ? 'Sim' : 'Não' }}</td>
                      <td class="text-center tabela_borda">{{ produtoCampanha.bonificacao_selecionavel ? 'Sim' : 'Não' }}</td>
                      <td class="text-center tabela_borda">{{ produtoCampanha.qtde_minima }}</td>
                    </tr>
                    @if (i == produtoCampanhaExpandido) {
                      <tr [@esvanecerDesvanecer]="'in'">
                        <td class="p-3" colspan="10">
                          <table class="table table-sm table-hover">
                            <thead>
                              <tr>
                                <th class="text-center">Código</th>
                                <th class="tabela_borda">Descrição</th>
                                <th class="text-center tabela_borda">Ativo</th>
                                <th class="text-center tabela_borda">Bonificação</th>
                                <th class="text-center tabela_borda">Qtde</th>
                                <th class="text-right tabela_borda">Preço: R$</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (produtoCampanhaItem of produtosCampanhaItens; track produtoCampanhaItem) {
                                <tr [ngClass]="produtoCampanhaItem.bonificacao ? 'bg_tabela_warning' : ''">
                                  <td class="text-center">{{ produtoCampanhaItem.codigo }}</td>
                                  <td class="tabela_borda">{{ produtoCampanhaItem.name }}</td>
                                  <td class="text-center tabela_borda">{{ produtoCampanhaItem.is_active ? 'Sim' : 'Não' }}</td>
                                  <td class="text-center tabela_borda">{{ produtoCampanhaItem.bonificacao ? 'Sim' : 'Não' }}</td>
                                  <td class="text-center tabela_borda">{{ produtoCampanhaItem.qtdade }}</td>
                                  <td class="text-right tabela_borda">{{ produtoCampanhaItem.preco | currency: 'BRL' }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              <app-pagination
                [page]="campPage"
                [totalPages]="campTotalPaginas"
                [totalItems]="campTotal"
                [pageSize]="campPageSize"
                (pageChange)="campMudarPagina($event)"
                (pageSizeChange)="campMudarPageSize($event)">
              </app-pagination>
            </div>
          </div>
        </ng-template>
      </li>
      <!-- Produtos -->
      <li [ngbNavItem]="'produtos'">
        <a ngbNavLink>
          <b>Produtos</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <!-- Filtro -->
            <form [formGroup]="formFiltroProduto" (ngSubmit)="filtrarProduto(false)">
              <div class="form-row">
                <div class="form-group col-sm-2">
                  <label class="text-secondary"><b>Filtrar por:</b></label>
                  <select class="form-control form-control-sm" name="filtrar_produto_por" formControlName="filtro" (change)="alterarFiltroProduto($event.target.value)">
                    @for (opcao of filtroProdutos; track opcao) {
                      <option [value]="opcao.valor" [selected]="opcao.valor == fp.filtro.value">{{ opcao.texto }}</option>
                    }
                  </select>
                </div>
                <!-- Código -->
                @if (fp.filtro.value == 0) {
                  <div class="form-group col-sm-2">
                    <label class="text-secondary"><b>Código:</b></label>
                    <input class="form-control form-control-sm" type="text" name="produto_codigo" [ngClass]="{ 'is-invalid': enviadoProduto && fp.codigo.errors?.required }" formControlName="codigo" />
                    @if (enviadoProduto && fp.codigo.errors?.required) {
                      <div class="erro pt-1">Código em branco!</div>
                    }
                  </div>
                }
                <!-- Descrição -->
                @if (fp.filtro.value == 1) {
                  <div class="form-group col-sm-7">
                    <label class="text-secondary"><b>Descrição:</b></label>
                    <input class="form-control form-control-sm" type="text" name="filtrar_descricao" [ngClass]="{ 'is-invalid': enviadoProduto && fp.descricao.errors?.required }" formControlName="descricao" />
                    @if (enviadoProduto && fp.descricao.errors?.required) {
                      <div class="erro pt-1">Descrição em branco!</div>
                    }
                  </div>
                }
                <!-- Marca -->
                @if (fp.filtro.value == 2) {
                  <div class="form-group col-sm-7">
                    <label class="text-secondary"><b>Marca:</b></label>
                    <input class="form-control form-control-sm" type="text" name="produto_marca" [ngClass]="{ 'is-invalid': enviadoProduto && fp.marca.errors?.required }" formControlName="marca" />
                    @if (enviadoProduto && fp.marca.errors?.required) {
                      <div class="erro pt-1">Marca em branco!</div>
                    }
                  </div>
                }
                <div class="col-sm-3">
                  <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
                  @if (filtrandoProduto) {
                    <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltroProduto(null)">Cancelar</button>
                  }
                  @if (podeExportarProdutos) {
                    <button class="btn btn-success btn_filtro" type="button" (click)="exportarProdutosFiltrados()">
                      <i class="fa fa-file-excel-o mr-1"></i>Exportar
                    </button>
                  }
                </div>
              </div>
            </form>
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-wrap align-content-start justify-content-start">
              <!-- Qtde Produtos -->
              <div class="quadros_numeros_lg p-2">
                <div class="d-flex align-items-center">
                  <div class="pl-2 pr-2">
                    <i class="fa fa-cubes quadros_numeros_icones"></i>
                  </div>
                  <div class="quadros_numeros_textos">
                    {{ produtos.length }}<br />Qtde Produtos
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <!-- Dados -->
            <div class="table-responsive">
              <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="text-center tabela_borda">Foto</th>
                      <th class="text-center tabela_borda bg_tabela_info" colspan="3">Portal Compras</th>
                      <th class="text-center tabela_borda">Código</th>
                      <th class="tabela_borda">Descrição</th>
                      <th class="text-right tabela_borda">Pontuacao</th>
                      <th class="text-right tabela_borda">Desc. Maximo</th>
                      <th class="tabela_borda">Grupo Estoque</th>
                      <th class="tabela_borda">Subgrupo Estoque</th>
                      <th class="tabela_borda">Subgrupo Estoque 2</th>
                      <th class="tabela_borda">Subgrupo Estoque 3</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (produto of produtosPagina; track produto.id) {
                    <tr>
                      <td class="text-center tabela_acao">
                        <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarProduto(produto.id)"></i>
                      </td>
                      <td class="text-center tabela_borda produto_thumb_cell">
                        <div class="produto_thumb" [ngClass]="{ 'produto_thumb_enviando': produtoFotoEnviando == produto.id }" [ngbTooltip]="produtoFotoCache[produto.id] ? 'Alterar foto' : 'Enviar foto'" placement="right" (click)="abrirUploadFotoProduto(produto, $event)">
                          @if (produtoFotoCache[produto.id]) {
                            <img [src]="produtoFotoCache[produto.id]" alt="Foto" />
                          } @else {
                            <i class="fa fa-camera produto_thumb_placeholder"></i>
                          }
                          @if (produtoFotoEnviando == produto.id) {
                            <i class="fa fa-spinner fa-spin produto_thumb_spinner"></i>
                          }
                        </div>
                      </td>
                      <td class="text-center tabela_acao_expandida tabela_borda bg_tabela_info">
                        @if (produto.mostrar_b2b == false) {
                          <div>
                            <i class="fa fa-lock btn_tabela_acao" placement="right" ngbTooltip="Liberar" (click)="liberarPortalCompras(produto.id, true)"></i>
                          </div>
                        }
                        @if (produto.mostrar_b2b != false) {
                          <div>
                            <i class="fa fa-unlock btn_tabela_acao" placement="right" ngbTooltip="Bloquear" (click)="liberarPortalCompras(produto.id, false)"></i>
                          </div>
                        }
                      </td>
                      <td class="text-center tabela_acao_expandida tabela_borda bg_tabela_info">
                        @if (produto.promocao != true) {
                          <div>
                            <i class="fa fa-check btn_tabela_acao" placement="right" ngbTooltip="Definir como Promoção" (click)="definirPromocao(produto.id, true)"></i>
                          </div>
                        }
                        @if (produto.promocao == true) {
                          <div>
                            <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Remover como Promoção" (click)="definirPromocao(produto.id, false)"></i>
                          </div>
                        }
                      </td>
                      <td class="text-center tabela_acao_expandida tabela_borda bg_tabela_info">
                        @if (exibirAtualizarProdutoTr(produto)) {
                          <div>
                            <i class="fa btn_tabela_acao"
                               [ngClass]="atualizandoProdutoTrId == produto.id ? 'fa-spinner fa-spin' : 'fa-refresh'"
                               placement="right"
                               ngbTooltip="Atualizar Produto TR"
                               (click)="atualizarProdutoTr(produto)"></i>
                          </div>
                        }
                      </td>
                      <td class="text-center tabela_borda">{{ produto.codigo }}</td>
                      <td class="tabela_borda">{{ produto.name }}</td>
                      <td class="text-right tabela_borda">{{ produto.pontuacao || 0 }}</td>
                      <td class="text-right tabela_borda">{{ produto.desc_maximo || 0 }}</td>
                      <td class="tabela_borda">{{ produto.grupo_estoque }}</td>
                      <td class="tabela_borda">{{ produto.subgrupo_estoque }}</td>
                      <td class="tabela_borda">{{ produto.subgrupo_estoque2 }}</td>
                      <td class="tabela_borda">{{ produto.subgrupo_estoque3 }}</td>
                    </tr>
                    }
                  </tbody>
                </table>
              <input class="produto_thumb_input" type="file" accept="image/png" #arquivoFotoLista (change)="onArquivoFotoListaSelecionado($event)" />
              <app-pagination
                [page]="produtosPage"
                [totalPages]="produtosTotalPaginas"
                [totalItems]="produtos.length"
                [pageSize]="produtosPageSize"
                [pageSizes]="produtosPageSizes"
                (pageChange)="produtosMudarPagina($event)"
                (pageSizeChange)="produtosMudarPageSize($event)">
              </app-pagination>
            </div>
          </div>
        </ng-template>
      </li>
      <!-- Custo -->
      <li [ngbNavItem]="'custo'">
        <a ngbNavLink>
          <b>Custo</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <!-- Gerar Modelo com Filtros -->
            <div class="card mb-3">
              <div class="card-header bg-light py-2">
                <b>Gerar modelo de custos com filtros</b>
              </div>
              <div class="card-body py-2">
                <!-- Descrição -->
                <div class="form-row mb-2">
                  <div class="form-group col-sm-6 mb-0">
                    <label class="text-secondary"><b>Descrição (opcional):</b></label>
                    <input class="form-control form-control-sm" type="text" [(ngModel)]="modeloCustosDescricao" placeholder="Ex: refrigerante (busca em código e descrição)" />
                  </div>
                </div>
                <!-- Linha de filtro: Filtrar por + Valor + Botões -->
                <div class="form-row align-items-end mb-2">
                  <div class="form-group col-sm-2 mb-0">
                    <label class="text-secondary"><b>Filtrar por:</b></label>
                    <select class="form-control form-control-sm" [(ngModel)]="modeloCustosFiltroSelecionado" (change)="modeloCustosAtualizarValoresDisponiveis()">
                      @for (tipo of modeloCustosTiposFiltro; track tipo) {
                        <option [value]="tipo.campo">{{ tipo.label }}</option>
                      }
                    </select>
                  </div>
                  <div class="form-group col-sm-4 mb-0">
                    <label class="text-secondary"><b>Valor:</b></label>
                    <select class="form-control form-control-sm" [(ngModel)]="modeloCustosValorSelecionado">
                      <option value="">Selecionar...</option>
                      @for (valor of modeloCustosValoresDisponiveis; track valor) {
                        <option [value]="valor">{{ valor }}</option>
                      }
                    </select>
                  </div>
                  <div class="form-group col-sm-6 mb-0">
                    <button class="btn btn-sm btn-info mr-2" type="button" (click)="modeloCustosAdicionarFiltro()" [disabled]="!modeloCustosValorSelecionado">
                      + Adicionar Filtro
                    </button>
                    <button class="btn btn-sm btn-success mr-2" type="button" (click)="modeloCustosGerarExcel()">
                      <i class="fa fa-file-excel-o"></i>&nbsp;Gerar Excel ({{ modeloCustosFiltrosAplicados.length }})
                    </button>
                    @if (modeloCustosFiltrosAplicados.length > 0 || modeloCustosDescricao) {
                      <button class="btn btn-sm btn-secondary" type="button" (click)="modeloCustosLimparFiltros()">
                        Limpar
                      </button>
                    }
                  </div>
                </div>
                <!-- Badges dos filtros aplicados -->
                @if (modeloCustosFiltrosAplicados.length > 0) {
                  <div class="d-flex flex-wrap mt-1">
                    @for (filtro of modeloCustosFiltrosAplicados; track filtro; let i = $index) {
                      <span class=" badge-filtro mr-2 mb-1">
                        {{ filtro.label }}: {{ filtro.valor }}
                        <span class="badge-filtro-remover ml-1" (click)="modeloCustosRemoverFiltro(i)">&times;</span>
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
            <!-- Cabeçalho -->
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-secondary"><b>Atualização de Custos via Excel</b></span>
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="custoBaixarModelo()">
                <i class="fa fa-download"></i>&nbsp;Baixar Modelo
              </button>
            </div>
            <hr class="mt-2 mb-3" />
            <!-- Upload + Configurações -->
            <div class="form-row align-items-end">
              <div class="form-group col-sm-5">
                <label class="text-secondary"><b>Planilha Excel (.xlsx):</b></label>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="custoFileInput" accept=".xlsx" (change)="custoOnArquivoSelecionado($event)" />
                  <label class="custom-file-label" for="custoFileInput">
                    {{ custoArquivo ? custoArquivo.name : 'Selecionar arquivo...' }}
                  </label>
                </div>
                <small class="text-muted">Máximo 1.000 linhas &mdash; Colunas: CODPROD, CUSTO, MARGEM</small>
              </div>
              <div class="form-group col-sm-3 pl-3">
                <div class="custom-control custom-checkbox mt-2">
                  <input type="checkbox" class="custom-control-input" id="cbAtualizarPromocoes" [(ngModel)]="custoAtualizarPromocoes" />
                  <label class="custom-control-label" for="cbAtualizarPromocoes">Atualizar promoções</label>
                </div>
              </div>
              <div class="form-group col-sm-4">
                <button class="btn btn-secondary btn-sm btn-block"
                  type="button"
                  (click)="custoEnviar()"
                  [disabled]="custoLinhas.length === 0 || custoEnviando">
                  @if (!custoEnviando) {
                    <i class="fa fa-upload"></i>&nbsp;Enviar ({{ custoLinhas.length }} iten(s))
                  }
                  @if (custoEnviando) {
                    <i class="fa fa-spinner fa-spin"></i>&nbsp;Processando lotes...
                  }
                </button>
              </div>
            </div>
            <!-- Erro de leitura -->
            @if (custoErroUpload) {
              <div class="alert alert-danger mt-1">
                <i class="fa fa-exclamation-triangle"></i>&nbsp;{{ custoErroUpload }}
              </div>
            }
            <!-- Preview da planilha -->
            @if (custoLinhas.length > 0 && !custoResultado && !custoEnviando) {
              <div class="alert alert-info mt-2">
                <i class="fa fa-info-circle"></i>&nbsp;<b>{{ custoLinhas.length }}</b> linha(s) válida(s) lida(s).
              </div>
              <div class="table-responsive">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th>CODPROD</th>
                      <th class="text-right tabela_borda">CUSTO (R$)</th>
                      <th class="text-right tabela_borda">MARGEM (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of custoLinhas.slice(0, 10); track item) {
                      <tr>
                        <td>{{ item.codprod }}</td>
                        <td class="text-right tabela_borda">{{ item.custo | currency:'BRL' }}</td>
                        <td class="text-right tabela_borda">{{ item.margem }}%</td>
                      </tr>
                    }
                    @if (custoLinhas.length > 10) {
                      <tr>
                        <td colspan="3" class="text-center text-muted">
                          <em>... e mais {{ custoLinhas.length - 10 }} linha(s)</em>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            <!-- Spinner durante envio -->
            @if (custoEnviando) {
              <div class="text-center mt-4 mb-4">
                <i class="fa fa-spinner quadros_numeros_icones fa-spin"></i>
                <p class="text-secondary mt-2">Enviando {{ custoLinhas.length }} item(ns) em lotes de 100... aguarde.</p>
              </div>
            }
            <!-- Resultado -->
            @if (custoResultado && !custoEnviando) {
              <!-- Resumo -->
              <div class="d-flex flex-wrap align-content-start justify-content-start mt-2">
                <div class="quadros_numeros_lg p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2"><i class="fa fa-list quadros_numeros_icones"></i></div>
                    <div class="quadros_numeros_textos">{{ custoResultado.totalLinhas }}<br />Total no arquivo</div>
                  </div>
                </div>
                <div class="quadros_numeros_lg p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2"><i class="fa fa-check-circle quadros_numeros_icones"></i></div>
                    <div class="quadros_numeros_textos">{{ custoResultado.total_atualizados }}<br />Atualizados</div>
                  </div>
                </div>
                <div class="quadros_numeros_lg p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2"><i class="fa fa-question-circle quadros_numeros_icones"></i></div>
                    <div class="quadros_numeros_textos">{{ custoResultado.total_nao_encontrados }}<br />Não encontrados</div>
                  </div>
                </div>
                <div class="quadros_numeros_lg p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2"><i class="fa fa-exclamation-circle quadros_numeros_icones"></i></div>
                    <div class="quadros_numeros_textos">{{ custoResultado.total_erros }}<br />Erros</div>
                  </div>
                </div>
              </div>
              <!-- Aviso de resposta truncada (totais OK, itens sem detalhe) -->
              @if (custoResultado.aviso) {
                <div class="alert alert-warning mt-3 mb-2">
                  <i class="fa fa-exclamation-triangle"></i>&nbsp;{{ custoResultado.aviso }}
                </div>
              }
              <hr class="mt-2 mb-3" />
              <!-- Resumo por lote -->
              <!-- <p class="text-secondary mb-1"><b>Detalhe por lote</b></p>
              <div class="table-responsive mb-3">
                <table class="table table-sm table-bordered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">Lote</th>
                      <th class="text-center">Itens enviados</th>
                      <th class="text-center">Atualizados</th>
                      <th class="text-center">Não encontrados</th>
                      <th class="text-center">Erros</th>
                      <th>Situação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let b of custoResultado.batches"
                      [ngClass]="!b.success ? 'table-danger' : (b.aviso ? 'table-warning' : '')">
                      <td class="text-center">{{ b.batchIndex }}/{{ custoResultado.totalBatches }}</td>
                      <td class="text-center">{{ b.batchSize }}</td>
                      <td class="text-center">{{ b.success ? b.total_atualizados : '—' }}</td>
                      <td class="text-center">{{ b.success ? b.total_nao_encontrados : '—' }}</td>
                      <td class="text-center">{{ b.success ? b.total_erros : b.batchSize }}</td>
                      <td>
                        <ng-container *ngIf="b.success && !b.aviso">
                          <span class="text-success"><i class="fa fa-check"></i> OK</span>
                        </ng-container>
                        <ng-container *ngIf="b.success && b.aviso">
                          <span class="text-warning"><i class="fa fa-exclamation-triangle"></i> Detalhamento parcial (resposta truncada)</span>
                        </ng-container>
                        <ng-container *ngIf="!b.success">
                          <span class="text-danger"><i class="fa fa-times"></i>&nbsp;<ng-container [ngSwitch]="b.errorCode">
                          <span *ngSwitchCase="'SAP_PARSE_ERROR'">Resposta inválida do SAP</span>
                          <span *ngSwitchCase="'SAP_HTTP_ERROR'">Falha de comunicação com o SAP</span>
                          <span *ngSwitchDefault>{{ b.errorMessage }}</span>
                        </ng-container></span>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> -->
            <!-- Produtos não encontrados -->
            @if (custoItensNaoEncontrados.length > 0) {
              <p class="text-secondary mb-1">
                <b>Produtos não encontrados</b>
                <span class="badge badge-warning ml-2">{{ custoResultado.total_nao_encontrados }}</span>
              </p>
              <div class="table-responsive mb-3">
                <table class="table table-sm table-bordered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>CODPROD</th>
                      <th class="text-right tabela_borda">Custo anterior (R$)</th>
                      <th class="text-right tabela_borda">Custo novo (R$)</th>
                      <th class="text-right tabela_borda">Venda (R$)</th>
                      <th class="tabela_borda">Mensagem</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of custoItensNaoEncontrados; track item) {
                      <tr>
                        <td>{{ item.codprod }}</td>
                        <td class="text-right tabela_borda">{{ item.custoantigo != null ? (item.custoantigo | currency:'BRL') : '—' }}</td>
                        <td class="text-right tabela_borda">{{ item.custonovo != null ? (item.custonovo | currency:'BRL') : '—' }}</td>
                        <td class="text-right tabela_borda">{{ item.venda != null ? (item.venda | currency:'BRL') : '—' }}</td>
                        <td class="tabela_borda text-muted">{{ item.mensagem }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            <!-- Itens com erro (status != UPDATED e != NOT_FOUND) -->
            @if (custoItensComErro.length > 0) {
              <p class="text-secondary mb-1">
                <b>Itens com erro</b>
                <span class="badge badge-danger ml-2">{{ custoItensComErro.length }}</span>
              </p>
              <div class="table-responsive mb-3">
                <table class="table table-sm table-bordered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>CODPROD</th>
                      <th class="tabela_borda">Status</th>
                      <th class="tabela_borda">Mensagem</th>
                      <th class="text-right tabela_borda">Venda (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of custoItensComErro; track item) {
                      <tr class="bg_tabela_warning">
                        <td>{{ item.codprod }}</td>
                        <td class="tabela_borda">{{ item.status }}</td>
                        <td class="tabela_borda">{{ item.mensagem }}</td>
                        <td class="text-right tabela_borda">
                          {{ item.venda != null ? (item.venda | currency:'BRL') : '—' }}
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            @if (custoItensComProblema.length === 0 && custoResultado.itens?.length > 0) {
              <div class="alert alert-success mt-2">
                <i class="fa fa-check-circle"></i>&nbsp;Todos os itens processados foram atualizados com sucesso.
              </div>
            }
            <div class="mt-3">
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="custoNovaImportacao()">
                <i class="fa fa-refresh"></i>&nbsp;Nova Importação
              </button>
            </div>
          }
        </div>
      </ng-template>
    </li>
    <!-- Promoções -->
    @if (!bloqueado('acessa_promocoes')) {
    <li [ngbNavItem]="'promocoes'">
      <a ngbNavLink>
        <b>Promoções</b>
      </a>
      <ng-template ngbNavContent>
        <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
          <!-- Ações -->
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary btn_titulo" type="button" (click)="novoProdutoTabelaEspecial()">Nova Promoção</button>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Filtros -->
          <div class="form-row align-items-end">
            <div class="form-group col-sm-4">
              <label class="text-secondary"><b>Descrição</b></label>
              <input class="form-control form-control-sm" type="text" placeholder="Buscar por descrição..." [(ngModel)]="promoFiltros.descricao" (keyup.enter)="promoBuscar()" />
            </div>
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>Ativo</b></label>
              <select class="form-control form-control-sm" [(ngModel)]="promoFiltros.ativo">
                <option [ngValue]="null">Todos</option>
                <option [ngValue]="true">Ativo</option>
                <option [ngValue]="false">Inativo</option>
              </select>
            </div>
            <div class="form-group col-sm-4 d-flex align-items-end">
              <button class="btn btn-secondary btn-sm mr-2" type="button" (click)="promoBuscar()" [disabled]="promoCarregando">Buscar</button>
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="promoLimpar()" [disabled]="promoCarregando">Limpar</button>
            </div>
          </div>
          <hr class="mt-1 mb-2" />
          <!-- Carregando -->
          @if (promoCarregando) {
            <div class="text-center py-4">
              <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
              <span class="ml-2 text-secondary">Buscando promoções...</span>
            </div>
          }
          <!-- Sem resultados -->
          @if (!promoCarregando && promoBuscaRealizada && promoItems.length === 0) {
            <div class="text-center text-secondary py-3">
              <small>Nenhuma promoção encontrada.</small>
            </div>
          }
          <!-- Tabela de resultados -->
          @if (!promoCarregando && promoItems.length > 0) {
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th></th>
                    <th class="tabela_borda"></th>
                    <th class="tabela_borda"></th>
                    <th class="tabela_borda">Nome</th>
                    <th class="text-center tabela_borda">Ativo</th>
                  </tr>
                </thead>
                <tbody>
                  @for (promo of promoItems; track promo; let i = $index) {
                    <tr>
                      <td class="text-center tabela_acao">
                        <i class="fa  btn_tabela_acao" [ngClass]="i == produtoTabelaEspecialExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirProdutoTabelaEspecial(i, promo.idprodutotabelaespecial)"></i>
                      </td>
                      <td class="text-center tabela_acao tabela_borda">
                        <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarProdutoTabelaEspecial(promo.idprodutotabelaespecial)"></i>
                      </td>
                      <td class="text-center tabela_acao tabela_borda">
                        <i class="fa fa-history btn_tabela_acao" placement="right" ngbTooltip="Ver Log" (click)="abrirLogPromo(promo.idprodutotabelaespecial, promo.descricao)"></i>
                      </td>
                      <td class="tabela_borda">{{ promo.descricao }}</td>
                      <td class="text-center tabela_borda">{{ promo.ativo ? 'Sim' : 'Não' }}</td>
                    </tr>
                    @if (i == produtoTabelaEspecialExpandido) {
                      <tr [@esvanecerDesvanecer]="'in'">
                        <td class="p-3" colspan="5">
                          <table class="table table-sm table-hover">
                            <thead>
                              <tr>
                                <th class="text-center">Código</th>
                                <th class="tabela_borda">Descrição</th>
                                <th class="text-center tabela_borda">Ativo</th>
                                <th class="text-center tabela_borda">Qtde Mínima</th>
                                <th class="text-right tabela_borda">Preço: R$</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (item of produtosTabelaEspecialItens; track item) {
                                <tr>
                                  <td class="text-center">{{ item.codigo }}</td>
                                  <td class="tabela_borda">{{ item.name }}</td>
                                  <td class="text-center tabela_borda">{{ item.ativo ? 'Sim' : 'Não' }}</td>
                                  <td class="text-center tabela_borda">{{ item.qtd_minima }}</td>
                                  <td class="text-right tabela_borda">{{ item.preco | currency: 'BRL' }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              <!-- Paginação -->
              <app-pagination
                [page]="promoPage"
                [totalPages]="promoTotalPaginas"
                [totalItems]="promoTotal"
                [pageSize]="promoPageSize"
                (pageChange)="promoMudarPagina($event)"
                (pageSizeChange)="promoMudarPageSize($event)">
              </app-pagination>
            </div>
          }
        </div>
      </ng-template>
    </li>
    }
    <!-- Tabela Especial -->
    @if (!bloqueado('acessa_tabela_especial')) {
    <li [ngbNavItem]="'tabela-especial'">
      <a ngbNavLink>
        <b>Tabela Especial</b>
      </a>
      <ng-template ngbNavContent>
        <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
          <!-- Ações -->
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary btn_titulo" type="button" (click)="novaTabelaEspecial()">Nova Tabela Especial</button>
          </div>
          <hr class="mt-2 mb-2" />
          <!-- Filtros -->
          <div class="form-row align-items-end">
            <div class="form-group col-sm-4">
              <label class="text-secondary"><b>Descrição</b></label>
              <input class="form-control form-control-sm" type="text" placeholder="Buscar por descrição..." [(ngModel)]="promoFiltros.descricao" (keyup.enter)="promoBuscar()" />
            </div>
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>Ativo</b></label>
              <select class="form-control form-control-sm" [(ngModel)]="promoFiltros.ativo">
                <option [ngValue]="null">Todos</option>
                <option [ngValue]="true">Ativo</option>
                <option [ngValue]="false">Inativo</option>
              </select>
            </div>
            <div class="form-group col-sm-4 d-flex align-items-end">
              <button class="btn btn-secondary btn-sm mr-2" type="button" (click)="promoBuscar()" [disabled]="promoCarregando">Buscar</button>
              <button class="btn btn-outline-secondary btn-sm" type="button" (click)="promoLimpar()" [disabled]="promoCarregando">Limpar</button>
            </div>
          </div>
          <hr class="mt-1 mb-2" />
          @if (promoCarregando) {
            <div class="text-center py-4">
              <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
              <span class="ml-2 text-secondary">Buscando tabelas especiais...</span>
            </div>
          }
          @if (!promoCarregando && promoBuscaRealizada && promoItems.length === 0) {
            <div class="text-center text-secondary py-3">
              <small>Nenhuma tabela especial encontrada.</small>
            </div>
          }
          @if (!promoCarregando && promoItems.length > 0) {
            <div class="table-responsive">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th></th>
                    <th class="tabela_borda"></th>
                    <th class="tabela_borda"></th>
                    <th class="tabela_borda">Nome</th>
                    <th class="text-center tabela_borda">Ativo</th>
                  </tr>
                </thead>
                <tbody>
                  @for (promo of promoItems; track promo; let i = $index) {
                    <tr>
                      <td class="text-center tabela_acao">
                        <i class="fa  btn_tabela_acao" [ngClass]="i == produtoTabelaEspecialExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandirProdutoTabelaEspecial(i, promo.idprodutotabelaespecial)"></i>
                      </td>
                      <td class="text-center tabela_acao tabela_borda">
                        <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarProdutoTabelaEspecial(promo.idprodutotabelaespecial)"></i>
                      </td>
                      <td class="text-center tabela_acao tabela_borda">
                        <i class="fa fa-history btn_tabela_acao" placement="right" ngbTooltip="Ver Log" (click)="abrirLogPromo(promo.idprodutotabelaespecial, promo.descricao)"></i>
                      </td>
                      <td class="tabela_borda">{{ promo.descricao }}</td>
                      <td class="text-center tabela_borda">{{ promo.ativo ? 'Sim' : 'Não' }}</td>
                    </tr>
                    @if (i == produtoTabelaEspecialExpandido) {
                      <tr [@esvanecerDesvanecer]="'in'">
                        <td class="p-3" colspan="5">
                          <table class="table table-sm table-hover">
                            <thead>
                              <tr>
                                <th class="text-center">Código</th>
                                <th class="tabela_borda">Descrição</th>
                                <th class="text-center tabela_borda">Ativo</th>
                                <th class="text-center tabela_borda">Qtde Mínima</th>
                                <th class="text-right tabela_borda">Preço: R$</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (item of produtosTabelaEspecialItens; track item) {
                                <tr>
                                  <td class="text-center">{{ item.codigo }}</td>
                                  <td class="tabela_borda">{{ item.name }}</td>
                                  <td class="text-center tabela_borda">{{ item.ativo ? 'Sim' : 'Não' }}</td>
                                  <td class="text-center tabela_borda">{{ item.qtd_minima }}</td>
                                  <td class="text-right tabela_borda">{{ item.preco | currency: 'BRL' }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
              <app-pagination
                [page]="promoPage"
                [totalPages]="promoTotalPaginas"
                [totalItems]="promoTotal"
                [pageSize]="promoPageSize"
                (pageChange)="promoMudarPagina($event)"
                (pageSizeChange)="promoMudarPageSize($event)">
              </app-pagination>
            </div>
          }
        </div>
      </ng-template>
    </li>
    }
  </ul>
  <div [ngbNavOutlet]="t"></div>
</div>

<!-- Modal: Log da Promoção -->
<ng-template #modalPromoLog let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Log de Alterações — {{ promoLogModalNome }}</h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    @if (promoLogModalCarregando) {
      <div class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
        <span class="ml-2 text-secondary">Carregando...</span>
      </div>
    }
    @if (!promoLogModalCarregando && promoLogModal.length === 0) {
      <div class="text-center text-secondary py-3">
        <small>Nenhum registro encontrado.</small>
      </div>
    }
    @if (!promoLogModalCarregando && promoLogModal.length > 0) {
      <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="tabela_borda">Data/Hora</th>
              <th class="text-center tabela_borda">Ação</th>
              <th class="text-center tabela_borda">Vendedor</th>
            </tr>
          </thead>
          <tbody>
            @for (log of promoLogModal; track log) {
              <tr>
                <td class="tabela_borda">{{ log.data_hora | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td class="text-center tabela_borda">{{ log.acao === 'criar' ? 'Criação' : 'Edição' }}</td>
                <td class="text-center tabela_borda">{{ log.seller_id }} — {{ log.seller_nome }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">Fechar</button>
  </div>
</ng-template>
}
